import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AreaSpalineCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { AREA_SPALINE_CHART } from "../../../../Data/Charts/ApexChart";

const AreaSpalineChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={AreaSpalineCharts} />
        <CardBody>
          <div id="area-spaline">
            <Chart options={AREA_SPALINE_CHART} series={AREA_SPALINE_CHART.series} type="area" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AreaSpalineChart;
